var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97967 6.02033C8.7116 6.28839 8.70267 6.72018 8.95942 6.9991L13.5628 12L8.95942 17.0009C8.70267 17.2798 8.7116 17.7116 8.97967 17.9797C9.26361 18.2636 9.72675 18.2544 9.99912 17.9593L14.8739 12.6783C15.2275 12.2952 15.2275 11.7048 14.8739 11.3217L9.99912 6.04071C9.72675 5.74565 9.26361 5.73639 8.97967 6.02033Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1b905cf6512ac786a71c6ac35692673b.svg";
export { ForwardRef as ReactComponent };